module.exports = {
      id: "erro-transfer-pix-usage",
      viewBox: "0 0 160 161",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#erro-transfer-pix",
      toString: function () {
        return this.url;
      }
    }